var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.products),function(product){return _c('div',{key:product},[_vm._v(" "+_vm._s(product)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }